import { render, staticRenderFns } from "./CarouselVirtualSlides.vue?vue&type=template&id=50e621f7&"
import script from "./CarouselVirtualSlides.vue?vue&type=script&lang=js&"
export * from "./CarouselVirtualSlides.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports